import React from 'react';
import { WhyChooseUsData } from '../ValuesPage';
import { ValueElement } from './ValueRow';

interface ValuesLivePreviewProps {
    valuesData: WhyChooseUsData;
}

const ValuesLivePreview: React.FC<ValuesLivePreviewProps> = ({ valuesData }) => {

    const activeElements = valuesData.elements.filter(item => item.isActive);

    const itemIcon = (item: ValueElement) => {
        if (item.url && item.url.trim() !== '') {
            return (
                <a 
                    key={item.id}
                    href={item.url} 
                    id='icon-one' 
                    className="iconsHome__card"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.preventDefault()}
                >
                    <div className="iconsHome__topArea">
                        <div className="iconsHome__icon">
                            {item.imageUrl && <img src={item.imageUrl} alt={item.title || ''} />}
                        </div>
                    </div>
                    <div className="iconsHome__bottomArea">
                        <div className="iconsHome__name">
                            {item.title && <h5>{item.title}</h5>}
                            {item.subtitle && <p>{item.subtitle}</p>}
                        </div>
                    </div>
                </a>
            );
        }
        
        if (!item.url || item.url.trim() === '') {
            return (
                <div key={item.id} id='icon-one' className="iconsHome__card">
                    <div className="iconsHome__topArea">
                        <div className="iconsHome__icon">
                            {item.imageUrl && <img src={item.imageUrl} alt={item.title || ''} />}
                        </div>
                    </div>
                    <div className="iconsHome__bottomArea">
                        <div className="iconsHome__name">
                            {item.title && <h5>{item.title}</h5>}
                            {item.subtitle && <p>{item.subtitle}</p>}
                        </div>
                    </div>
                </div>
            );
        }
    };

    const icons = activeElements.map(item => itemIcon(item));

    const activeCount = activeElements.length || 1;
    const desktopCols = activeCount >= 3 && activeCount <= 6 ? activeCount : 3;

    return (
        <div className="values-preview-container mt-4">
            <h3 className="mb-3">Live Preview</h3>
            
            <section className='iconsHome'>
                <div className="iconsHome__container">
                    
                    {valuesData.sectionTitle && (
                        <div className="iconsHome__title">
                            <h2>{valuesData.sectionTitle}</h2>
                        </div>
                    )}
                    
                    <div
                        className="iconsHome__flex"
                        style={{ "--icon-count": activeCount, "--icon-cols": desktopCols } as React.CSSProperties}
                    >
                        {icons}
                    </div>

                </div>
            </section>
        </div>
    );
};

export default ValuesLivePreview;